export class InvoicePdfEmailInputDto {
    emailAddress = '';
    ccRecipients='';
    subject = '';
    body = '';
    invoiceIds: number[] = [];
    LoggedInUserEmail='';
}